import type Variant from '@modules/product/type/variant';

const getLowestPriceInStockVariant = (
    Variants: Variant[],
): Variant | undefined => {
    const variants = Variants ?? [];
    const sortedVariants = variants.sort(
        (a, b) => a.Price.Amount - b.Price.Amount,
    );
    const cheapestInStock = sortedVariants.find(
        (variant) => variant.AvailableStock > 0,
    );

    return cheapestInStock;
};

export default getLowestPriceInStockVariant;
